"use strict";

exports.__esModule = true;
exports.Well = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Text = require("../../Elements/Text/Text");
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Well = ({
  title,
  subline,
  onClick
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-well",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-e-well__inner",
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        onClick: onClick,
        className: "title-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
          content: title,
          type: "interactive-text"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          type: "chevron-right"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-e-well__inner-subline",
        dangerouslySetInnerHTML: {
          __html: subline
        }
      })]
    })
  });
};
exports.Well = Well;